import OnDOMReady from "shared/util/OnDOMReady";
import Context from "shared/util/Context";
import isSpa from "shared/util/isSpa";
import SentryHelper, { DSN } from "shared/util/SentryHelper";
import { isDesktop, isDev } from "shared/util/EnvironmentHelpers";

OnDOMReady(() => {
	// Initialize Sentry.
	if (isDev || isSpa()) {
		return;
	}

	SentryHelper.initSentry({
		dsn: isDesktop
			? DSN.Desktop
			: DSN.Mobile,
		userid: Context.get("userid"),
		environment: Context.get("env"),
		release: Context.get("activeRevision"),
	});
});



// WEBPACK FOOTER //
// ./src/features/sentry/index.js